var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgressGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 34.21,
    y: 33.88,
    width: 240.93,
    height: 262.76,
    style: {
      fill: "#ebf2f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.61,267.76s.37,5.9,1.51,6c.15,0,5.79,0,5.79,0l7.2-.05a2.34,2.34,0,0,0-2.15-2.1c-2.11-.36-5.63-1.84-6.9-4.62C121.72,264.06,117.61,267.76,117.61,267.76Z",
    style: {
      fill: "#163560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,198.9s3.14.81,5.13.21,5.42.38,6,1.11.34,1-.64,1.26-4.48,1.74-6.77.88a18.34,18.34,0,0,0-5.29-.89Z",
    style: {
      fill: "#e49963"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,171.66s3.52,25,9.36,27.28c2.87,1.11,15.59,3.61,19.36,3.87,0,0,.92-.75.69-3.8,0,0-13.32-4.89-15.22-7.55-2.81-4,1.75-16.17-1.78-19.89S90.84,166.25,87.92,171.66Z",
    style: {
      fill: "#4a75cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.37,268.12v-5.46H79.78a.42.42,0,0,1-.42-.42v-.87a.42.42,0,0,1,.42-.42h8.59V229.88A1.59,1.59,0,0,1,90,228.29h1.7a1.59,1.59,0,0,1,1.58,1.59V261h8.6a.42.42,0,0,1,.42.42v.87a.42.42,0,0,1-.42.42h-8.6v5.46c6.22.47,11.2,2.71,12.6,5.6H75.78C77.17,270.83,82.15,268.59,88.37,268.12Z",
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.11,224.41a44.09,44.09,0,0,0,3.44,4.92c3.79,4.78,7.91,8.72,8.62,12.44a17.89,17.89,0,0,0,.67,2.39c.3.85.67,1.75,1.1,2.67a82.07,82.07,0,0,0,6.41,11c4.14,6.14,8,11.27,8,11.27l7.15-.31c-.29-.71-3.4-9.2-7.58-19.56l-5.23-13-.69-1.72c-.53-1.32-1.06-2.62-1.57-3.88-3.91-9.74-7-17.49-7-17.49S86.78,207.16,85.15,211C83.81,214.17,84.9,217.28,89.11,224.41Z",
    style: {
      fill: "#e58638"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.06,250.9s-5,3.2-4.49,4.24c.06.13,2.81,5.06,2.81,5.06l3.54,6.26a2.34,2.34,0,0,0,.79-2.9c-.71-2-1.13-5.81.67-8.28S101.06,250.9,101.06,250.9Z",
    style: {
      fill: "#163560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.79,210.27s19.65,12.25,21.84,20.47-26.14,25.78-26.14,25.78-3.11-2.74-3.66-4.75c0,0,12.81-15.35,15.59-18.79,1.71-2.11-25.23-7.31-28.52-12.43s-2.11-9.43-2.11-9.43Z",
    style: {
      fill: "#ee9849"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.23,
    y: 225.99,
    width: 43.15,
    height: 10.97,
    rx: 1.46,
    style: {
      fill: "#1c468a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7,167.37a11.08,11.08,0,0,1,3,2.72c-4.71,1.21-12.51-3.15-12.51-3.15a11.56,11.56,0,0,0,4.15-6.51c.06-.23.11-.46.16-.69a14.3,14.3,0,0,0,.25-2.45l2.16,1.93,3.6,3.22a30.61,30.61,0,0,1-.53,3.64Q98.85,166.68,98.7,167.37Z",
    style: {
      fill: "#e49963"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.22,189.58c.67,9.07-.46,22.86.3,25.25.66,2.06,8.43.84,11.43.16,1.12-.26,2.46-.62,3.85-1.05,3.88-1.2,8.11-2.92,8.56-4.19a.83.83,0,0,0,0-.15,1.18,1.18,0,0,0,0-.53,9.16,9.16,0,0,1-.8-3c-.08-1.79-.06-3.91-.13-6.18a7.09,7.09,0,0,0,0-.79v-.24c-.07-2.53-.2-5.19-.35-7.83-.1-1.66-.21-3.3-.34-4.88a65.73,65.73,0,0,0-1.4-10,16,16,0,0,0-5.14-7.93l-1.43-1.23a8.25,8.25,0,0,1-5.19-.69c-1.85-.88-2.49-1.51-2.81-1.27C86.49,168.4,83.42,178.49,84.22,189.58Z",
    style: {
      fill: "#739af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.78,214c3.88-1.2,8.1-2.91,8.56-4.18a.83.83,0,0,0,0-.15c0-.18,0-.36,0-.53a9.16,9.16,0,0,1-.8-3c-.08-1.8-.07-3.91-.13-6.18,0-.26,0-.53,0-.79v-.24l-14.65-6.64A34.1,34.1,0,0,0,99.78,214Z",
    style: {
      fill: "#4a75cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5,162.44a30.61,30.61,0,0,1-.53,3.64,9.54,9.54,0,0,1-5.64-5.65,5.54,5.54,0,0,1-.21-.62l.37-.07,2.41-.52Z",
    style: {
      fill: "#d68d5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.92,162.41s-7.71.87-8.18-3.94-1.78-7.95,3.13-8.7,6,1,6.59,2.55S102.92,162.06,100.92,162.41Z",
    style: {
      fill: "#e49963"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.77,158.8a7.93,7.93,0,0,1,7.51-7.05c4.81-.45,2.13-4.6,1.62-5.26,0,0-3.69.51-7.46,1.13C86.51,148.93,92,157.8,92.77,158.8Z",
    style: {
      fill: "#2b478b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.97,
    y: 187.14,
    width: 0.71,
    height: 18.59,
    transform: "translate(199.43 424.47) rotate(-162)",
    style: {
      fill: "#4a75cb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.3,
    y: 204.02,
    width: 19.51,
    height: 1.17,
    transform: "translate(237.71 411.74) rotate(-178.78)",
    style: {
      fill: "#4a75cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.41,202.75s3,1.15,5.07.77,5.35,1,5.82,1.76.23,1.05-.77,1.19-4.65,1.24-6.83.13a18.3,18.3,0,0,0-5.16-1.47Z",
    style: {
      fill: "#e49963"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.48,172.69s.74,25.27,6.29,28.14c2.74,1.42,15.1,5.31,18.81,6,0,0,1-.64,1.11-3.69,0,0-12.7-6.33-14.29-9.19-2.36-4.24,3.52-15.88.42-20S93,167.63,89.48,172.69Z",
    style: {
      fill: "#739af0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.19,
    y: 85.13,
    width: 126.11,
    height: 163.09,
    rx: 12.72,
    transform: "translate(67.57 400.91) rotate(-90)",
    style: {
      fill: "#d2e4ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.18,
    y: 102.03,
    width: 101.54,
    height: 129.49,
    transform: "translate(67.18 400.72) rotate(-90)",
    style: {
      fill: "#f3f9ff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.800000011920929
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.89,203.14h0a5.36,5.36,0,0,1,5.36-5.35h74.07a5.35,5.35,0,0,1,5.35,5.35h0a5.35,5.35,0,0,1-5.35,5.36H180.25A5.36,5.36,0,0,1,174.89,203.14Z",
    style: {
      fill: "#82b378"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.89,185.59h0a5.36,5.36,0,0,1,5.36-5.36H278a5.36,5.36,0,0,1,5.36,5.36h0A5.36,5.36,0,0,1,278,191h-97.7A5.36,5.36,0,0,1,174.89,185.59Z",
    style: {
      fill: "#efc44b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.89,166.44h0a5.36,5.36,0,0,1,5.36-5.36h53.56a5.36,5.36,0,0,1,5.36,5.36h0a5.35,5.35,0,0,1-5.36,5.35H180.25A5.35,5.35,0,0,1,174.89,166.44Z",
    style: {
      fill: "#65c2af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.89,147.8h0a5.36,5.36,0,0,1,5.36-5.36h83.23a5.36,5.36,0,0,1,5.35,5.36h0a5.36,5.36,0,0,1-5.35,5.36H180.25A5.36,5.36,0,0,1,174.89,147.8Z",
    style: {
      fill: "#3598fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.09,134.42H180.25a5.36,5.36,0,0,1-5.36-5.36h0a5.36,5.36,0,0,1,5.36-5.35h94.84a5.36,5.36,0,0,1,5.35,5.35h0A5.36,5.36,0,0,1,275.09,134.42Z",
    style: {
      fill: "#a373ff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.79,132a3.34,3.34,0,1,1,3.33-3.34A3.35,3.35,0,0,1,169.79,132Zm0-5.38a2,2,0,1,0,2,2A2.05,2.05,0,0,0,169.79,126.61Z",
    style: {
      fill: "#6a88a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.37,126.61a.63.63,0,0,1-.46-.19l-10-10H76.49a.65.65,0,1,1,0-1.29h81.94l10.39,10.4a.63.63,0,0,1,0,.91A.61.61,0,0,1,168.37,126.61Z",
    style: {
      fill: "#6a88a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.89,111.45H77.41a1.63,1.63,0,0,1-1.63-1.63h0a1.63,1.63,0,0,1,1.63-1.64h53.48a1.64,1.64,0,0,1,1.64,1.64h0A1.64,1.64,0,0,1,130.89,111.45Z",
    style: {
      fill: "#739af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.89,106.29H98.06a1.63,1.63,0,0,1-1.63-1.64h0A1.63,1.63,0,0,1,98.06,103h32.83a1.64,1.64,0,0,1,1.64,1.63h0A1.64,1.64,0,0,1,130.89,106.29Z",
    style: {
      fill: "#739af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.89,101.13H98.06a1.63,1.63,0,0,1-1.63-1.64h0a1.63,1.63,0,0,1,1.63-1.63h32.83a1.64,1.64,0,0,1,1.64,1.63h0A1.64,1.64,0,0,1,130.89,101.13Z",
    style: {
      fill: "#739af0"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressGraphic);
export default __webpack_public_path__ + "static/media/progress_graphic.66a65ef26b7a20be8681489913f9c567.svg";
export { ForwardRef as ReactComponent };